var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6683 13.2229L0.778824 2.33345C0.312133 1.86676 0.312133 1.24451 0.778824 0.777817C1.24551 0.311127 1.86777 0.311127 2.33446 0.777817L13.2239 11.6673C13.6906 12.1339 13.6906 12.7562 13.2239 13.2229C12.7572 13.6896 12.135 13.6896 11.6683 13.2229Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.33369 13.2229L13.2231 2.33345C13.6898 1.86676 13.6898 1.24451 13.2231 0.777817C12.7564 0.311127 12.1342 0.311127 11.6675 0.777817L0.778058 11.6673C0.311369 12.1339 0.311368 12.7562 0.778058 13.2229C1.24475 13.6896 1.867 13.6896 2.33369 13.2229Z",
    fill: "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.7aa018f474b22602ba8e11376b6cf8bf.svg";
export { ForwardRef as ReactComponent };